import { Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";
import React, { useState, useEffect } from "react";
import SnapshotImg from "../../../Assets/Images/Snapshort.png";
const overviewImg = require("../../../Assets/Images/Overview.png");
const LatoRegular = require("../../../Assets/Fonts/Lato-Font/Lato-Regular.ttf");
const LatoBold = require("../../../Assets/Fonts/Lato-Font/Lato-Bold.ttf");
const HeartToSoul = require("../../../Assets/Images/HeartToSoul.png");
const logo1 = require('../../../Assets/Images/logo1.png')
const logo5 = require('../../../Assets/Images/logo5.png')
const logo6 = require('../../../Assets/Images/logo6.png')
const logo7 = require('../../../Assets/Images/logo7.png')
const flow_HS = require( '../../../Assets/Images/flowScoreIcons/H-S.png')
const flow_HM = require( '../../../Assets/Images/flowScoreIcons/H-M.png')
const flow_HST = require( '../../../Assets/Images/flowScoreIcons/H-ST.png')
const flow_MH = require( '../../../Assets/Images/flowScoreIcons/M-H.png')
const flow_MS = require( '../../../Assets/Images/flowScoreIcons/M-S.png')
const flow_MST = require( '../../../Assets/Images/flowScoreIcons/M-ST.png')
const flow_SH= require( '../../../Assets/Images/flowScoreIcons/S-H.png')
const flow_SM = require( '../../../Assets/Images/flowScoreIcons/S-M.png')
const flow_SST = require( '../../../Assets/Images/flowScoreIcons/S-ST.png')
const flow_STH = require( '../../../Assets/Images/flowScoreIcons/ST-H.png')
const flow_STM = require( '../../../Assets/Images/flowScoreIcons/ST-M.png')
const flow_STS = require( '../../../Assets/Images/flowScoreIcons/ST-S.png')
const collaborativelogo = require('../../../Assets/Images/COLLABORATIVE.png')
const visionarylogo = require('../../../Assets/Images/VISIONARY.png')
const performancelogo = require('../../../Assets/Images/PERFORMANCE.png')
const stratrgiclogo = require('../../../Assets/Images/STRATEGIC.png')
const FixedLogo = require("../../../Assets/Images/fixed-new.png")
const ConditionalLogo = require("../../../Assets/Images/conditional_edit.png")
const GrowthLogo = require('../../../Assets/Images/growth-new.png')


Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  coverSection: {
    margin: "5px",
    padding: "5px",
    borderRadius: "5px",
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "center",
    fontFamily: "Lato",
    backgroundColor: "#ffffff",
  },
  coverTitle: {
    marginBottom: "20px",
    fontSize: "24px",
    fontWeight: 700,
    lineHeight: "35px",
    color: "#426B88",
    fontFamily: "Lato",
    textAlign: "left",
  },
  secondsection: {
    marginTop: "10px",
    // borderRadius: "5px",
    // width: "100%",
    // paddingRight: "20px",
    // flexDirection: "column",
    alignItems: "flex-start",
    // display: "flex",
    justifyContent: "flex-start",
    // flexDirection: "column",
    fontFamily: "Lato",
    color: "#426B88",
    fontSize: "12px",
    lineHeight: "18px",
    fontFamily: "Lato",
    fontWeight: 700,
    height: "18px",
    // backgroundColor: "#ffffff",
  },
  subtitle: {
    fontSize: "12px",
    lineHeight: "18px",
    fontFamily: "Lato",
    fontWeight: "700",
    color: "#426B88",
    justifyContent: "flex-start",
    display: "flex",
  },
  paragraph: {
    fontFamily: "Lato",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#245775",
    textAlign: "justify",
  },
  coverImage: {
    width: "100%",
    maxWidth: "400px",
    marginTop: "20px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  detailSection: {
    width: "200px",
    height: "170px",
    marginTop: "30px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "Lato",
  },
  detailTitle: {
    fontWeight: 700,
    fontSize: "16px",
    lineHeight: "20px",
    color: "#245775",
    fontFamily: "Lato",
  },
  detailSubtitle: {
    marginTop: "10px",
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "18px",
    color: "#245775",
    textAlign: "center",
    fontFamily: "Lato",
  },
  author: {
    marginTop: "30px",
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "17px",
    color: "#245775",
    textAlign: "center",
    fontFamily: "Lato",
  },
  section: {
    marginTop: "10px",
    textAlign: "left",
    maxWidth: "800px",
    marginLeft: "auto",
    marginRight: "auto",
  },
  title: {
    fontSize: "18px",
    fontWeight: 700,
    color: "#245775",
    textAlign: "left",
    marginTop: "20px",
    fontFamily: "Lato",
  },
  image: {
    width: "100%",
    maxWidth: "30px",
    maxHeight: "30px",
    borderRadius: "100px"
  },
  section_container: {
    maxWidth: "400px",
    gap: "45px",
    flexDirection: "column",
    margin: "0 auto",
    paddingTop: "25px"
  },
  card1: {
    flexDirection: "row",
    gap: "25px",
    alignItems: "stretch"    
  },
  card2: {
    flexDirection: "row",
    gap: "25px",
    alignItems: "stretch"
  },
  sections: {
    width: "50%",
    justifyContent: "start",
    alignItems: "center",
    flexDirection: "column",
    border: "2px solid #00577D",
    padding: "23px",
    borderRadius: "20px",
    position: "relative",
    margin: "0 auto",
  }, 
  titles: {
    position: "absolute",
    top: "-13%",
    textAlign: "center",
    backgroundColor: "#FFFFFF",
    padding: "0 16px",
    fontSize: "13px",
    color: "#505050"
  },
  aligns: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "0 22px",
    gap: "16px"
  }
});
const AboutReport = ({ apiData }) => {
  const [highestStarter, setHighestStarter] = useState('')
  const [variablsMapArray, setVariableMapArray] = useState()
  const [mostSelecTedStarter, setMostSelecTedStarter] = useState('')
  const [secondMostSelecTedStarter, setSecondMostSelecTedStarter] = useState('')
  const [highestLeadershipStarter, setHighestLeadershipStarter] = useState('')
  const [leadershipSnapshotResults, setLeadershipSnapshotResults] = useState([])
  const [growthMindset, setGrowthMindset] = useState('')


  const pairs = [
    { round1: "heart_round1_m", round2: "heart_round2_m" },
    { round1: "soul_round1_m", round2: "soul_round2_m" },
    { round1: "str_round1_m", round2: "str_round2_m" },
    { round1: "mind_round1_m", round2: "mind_round2_m" }
  ];

  const leadershipPairs = [
    { round1: "col_round1_m", round2: "col_round2_m" },
    { round1: "strat_round1_m", round2: "strat_round2_m" },
    { round1: "per_round1_m", round2: "per_round2_m" },
    { round1: "vis_round1_m", round2: "vis_round2_m" }
  ]


  const variableMap = apiData?.variables?.reduce((acc, el) => {
    acc[el.variable] = el.score;
    return acc;
  }, {});
  useEffect(() => {
    if (variableMap) {
      setVariableMapArray(variableMap);
    }
    getMostAndSecondMostVaribale(apiData)
  }, [apiData]);

  useEffect(() => {
    let highestScore = -Infinity;
    let highestVariable = "";
    let results = [];
    let labelsArray = [];

    if (variablsMapArray) {
      console.log(variablsMapArray);
      const heart_r1_m = variablsMapArray["heart_round1_m"] || 0;
      const soul_r1_m = variablsMapArray["soul_round1_m"] || 0;
      const mind_r1_m = variablsMapArray["mind_round1_m"] || 0;
      const strength_r1_m = variablsMapArray["str_round1_m"] || 0;

      const heart_r2_m = variablsMapArray["heart_round2_m"] || 0;
      const soul_r2_m = variablsMapArray["soul_round2_m"] || 0;
      const mind_r2_m = variablsMapArray["mind_round2_m"] || 0;
      const strength_r2_m = variablsMapArray["str_round2_m"] || 0;

      const heart_r1_l = variablsMapArray["heart_round1_l"] || 0;
      const soul_r1_l = variablsMapArray["soul_round1_l"] || 0;
      const mind_r1_l = variablsMapArray["mind_round1_l"] || 0;
      const strength_r1_l = variablsMapArray["str_round1_l"] || 0;

      const heart_r2_l = variablsMapArray["heart_round2_l"] || 0;
      const soul_r2_l = variablsMapArray["soul_round2_l"] || 0;
      const mind_r2_l = variablsMapArray["mind_round2_l"] || 0;
      const strength_r2_l = variablsMapArray["str_round2_l"] || 0;

      const heart_highest = Math.max(heart_r1_m, heart_r2_m, heart_r1_l, heart_r2_l);
      const mind_highest = Math.max(mind_r1_m, mind_r2_m, mind_r1_l, mind_r2_l);
      const soul_highest = Math.max(soul_r1_m, soul_r2_m, soul_r1_l, soul_r2_l);
      const strength_highest = Math.max(strength_r1_m, strength_r2_m, strength_r1_l, strength_r2_l);
      

      console.log("Heart Highest = " + heart_highest + "\nMind Highest = " + mind_highest + "\nSoul Highest = " + soul_highest + "\nStrength Highest = " + strength_highest);
      // let testingVarsM2 = [heart_r2 + heart_r1_m, soul_r2 + soul_round1_m, mind_r2 + mind_round1_m, strength_r2 + strength_round1_m];
      let testingVarsM2Pair = [{"name": "heart", "score": heart_highest},{"name": "soul", "score": soul_highest},{"name": "mind", "score": mind_highest}, {"name": "strength", "score": strength_highest}];
      console.log("testingVarsM2Pair",testingVarsM2Pair);

      highestVariable = testingVarsM2Pair.reduce((max, current) => 
        current.score > max.score ? current : max, { name: "", score: -Infinity }
      );


      let most_score = Math.max(heart_r1_m,soul_r1_m,mind_r1_m,strength_r1_m)
      let second_most_score = Math.max(heart_r2_m,soul_r2_m,mind_r2_m,strength_r2_m) / 2
      let least_score = Math.max(heart_r1_l,soul_r1_l,mind_r1_l,strength_r1_l)
      let second_least_score = Math.max(heart_r2_l,soul_r2_l,mind_r2_l,strength_r2_l) / 2

      console.log("heart_r2_l,soul_r2_l,mind_r2_l,strength_r2_l",heart_r2_l,soul_r2_l,mind_r2_l,strength_r2_l)
      if ( least_score >= second_least_score ) {
        least_score = ( second_least_score - 1 )
      }

      const total = most_score + second_most_score + least_score + second_least_score;

      const most_per = (most_score / total) * 100;
      const second_most_per = (second_most_score / total) * 100;
      const least_per = (least_score / total) * 100;
      const second_least_per = (second_least_score/ total) * 100 

      console.log("scores-",most_score,second_most_score,least_score,second_least_score)
      console.log("scores-per",most_per,second_most_per,least_score,second_least_per)

  
      let labels = testingVarsM2Pair.map(item => item.name);

      const labels_arr = ["heart", "soul", "mind", "strength"];

      const mostValues = [heart_r1_m, soul_r1_m, mind_r1_m, strength_r1_m];
      const secondMostValues = [heart_r2_m, soul_r2_m, mind_r2_m, strength_r2_m];
      const leastValues = [heart_r1_l, soul_r1_l, mind_r1_l, strength_r1_l];
      const secondLeastValues = [heart_r2_l, soul_r2_l, mind_r2_l, strength_r2_l];

      const most_score_label = Math.max(...mostValues);
      const second_most_score_label = Math.max(...secondMostValues);
      const least_score_label = Math.max(...leastValues);
      const second_least_score_label = Math.max(...secondLeastValues);

      const getLabel = (values, maxValue) => labels_arr[values.indexOf(maxValue)];

      const most_label = getLabel(mostValues, most_score_label);
      const second_most_label = getLabel(secondMostValues, second_most_score_label);
      const least_label = getLabel(leastValues, least_score_label);
      const second_least_label = getLabel(secondLeastValues, second_least_score_label);

      console.log(most_label , 'most_label')
      const getPercentageOrder = ( label ) => {
        if ( label == most_label?.toLowerCase() ) {
          return most_per;
        }
        if ( label == second_most_label?.toLowerCase() ) {
          return second_most_per;
        }
        if ( label == least_label?.toLowerCase() ) {
          return least_per;
        }
        if ( label == second_least_label?.toLowerCase() ) {
          return second_least_per;
        }

        return 0
      }

      console.log("scores- starter",most_score,second_most_score,least_score,second_least_score)
      console.log("scores-per-starter",most_per,second_most_per,least_score,second_least_per)

      // order should be most > second most > least > second least
      // results = [getPercentageOrder("mind"), getPercentageOrder("soul"), getPercentageOrder("strength"), getPercentageOrder("heart")] // label order = 'mind', 'soul', 'strength', 'heart'
      results = [getPercentageOrder("strength"), getPercentageOrder("heart"), getPercentageOrder("soul"), getPercentageOrder("mind")] // label order = 'mind', 'soul', 'strength', 'heart'
     
      // labelsArray = [...labelsArray, ...labels];
      // labelsArray = [least_label, second_least_label, second_most_label, most_label];
      labelsArray = ['mind', 'soul', 'strength', 'heart'];

      console.log('highestVariable', highestVariable)
      console.log("pie chart results", results);
      console.log("pie chart labelsArray", labelsArray);

      setHighestStarter(most_label);
      // setStarterScore(most_per);
      // setSnapshotResults(results);
      // setStarterLabel(labelsArray);
      getMostAndSecondMostVaribale(apiData)

    }

  }, [variablsMapArray]);

  useEffect(() => {

    let highestScore = -Infinity;
    let highestVariable = "";
    let results = [];
    let labelsArray = [];

    if (variablsMapArray) {
      console.log(variablsMapArray);
      const performance_r1_m = variablsMapArray["per_round1_m"] || 0;
      const strategic_r1_m = variablsMapArray["strat_round1_m"] || 0;
      const visionary_r1_m = variablsMapArray["vis_round1_m"] || 0;
      const collaborative_r1_m = variablsMapArray["col_round1_m"] || 0;

      const performance_r2_m = variablsMapArray["per_round2_m"] || 0;
      const strategic_r2_m = variablsMapArray["strat_round2_m"] || 0;
      const visionary_r2_m = variablsMapArray["vis_round2_m"] || 0;
      const collaborative_r2_m = variablsMapArray["col_round2_m"] || 0;

      const performance_r1_l = variablsMapArray["per_round1_l"] || 0;
      const strategic_r1_l = variablsMapArray["strat_round1_l"] || 0;
      const visionary_r1_l = variablsMapArray["vis_round1_l"] || 0;
      const collaborative_r1_l = variablsMapArray["col_round1_l"] || 0;

      const performance_r2_l = variablsMapArray["per_round2_l"] || 0;
      const strategic_r2_l = variablsMapArray["strat_round2_l"] || 0;
      const visionary_r2_l = variablsMapArray["vis_round2_l"] || 0;
      const collaborative_r2_l = variablsMapArray["col_round2_l"] || 0;


      const collaborative_highest = Math.max(collaborative_r1_m, collaborative_r2_m, collaborative_r1_l, collaborative_r2_l);
      const strategic_highest = Math.max(strategic_r1_m, strategic_r2_m, strategic_r1_l, strategic_r2_l);
      const performance_highest = Math.max(performance_r1_m, performance_r2_m, performance_r1_l, performance_r2_l);
      const visionary_highest = Math.max(visionary_r1_m, visionary_r2_m, visionary_r1_l, visionary_r2_l);
      

      let most_score = Math.max(performance_r1_m,strategic_r1_m,visionary_r1_m,collaborative_r1_m)
      let second_most_score = Math.max(performance_r2_m,strategic_r2_m,visionary_r2_m,collaborative_r2_m) / 2
      let least_score = Math.max(performance_r1_l,strategic_r1_l,visionary_r1_l,collaborative_r1_l)
      let second_least_score = Math.max(performance_r2_l,strategic_r2_l,visionary_r2_l,collaborative_r2_l) / 2

      if ( least_score >= second_least_score ) {
        least_score = ( second_least_score - 1 )
      }

      const total = most_score + second_most_score + least_score + second_least_score;

      const most_per = (most_score / total) * 100;
      const second_most_per = (second_most_score / total) * 100;
      const least_per = (least_score / total) * 100;
      const second_least_per = (second_least_score/ total) * 100 

      console.log("scores-",most_score,second_most_score,least_score,second_least_score)
      console.log("scores-per",most_per,second_most_per,least_score,second_least_per)

      let testingVarsM2Pair = [{"name": "collaborative", "score": collaborative_highest},{"name": "strategic", "score": strategic_highest},{"name": "performance", "score": performance_highest}, {"name": "visionary", "score": visionary_highest}];

      highestVariable = testingVarsM2Pair.reduce((max, current) => 
        current.score > max.score ? current : max, { name: "", score: -Infinity }
      );

      console.log(highestVariable);
  
      let scores = testingVarsM2Pair.map(item => item.score);
      results = [...results, ...scores]; 
  
      let labels = testingVarsM2Pair.map(item => item.name);
      labelsArray = [...labelsArray, ...labels];

      leadershipPairs?.forEach(pair => {
        const round1Obj = apiData?.variables.find(v => v.variable === pair.round1);
        const round2Obj = apiData?.variables.find(v => v.variable === pair.round2);
        console.log("apiData", apiData)
        
        console.log("pie chart round1Obj", round1Obj)
        console.log("pie chart round2Obj", round2Obj)
        if (round1Obj && round2Obj) {
          const snapshotResult = round1Obj.score
          results.push(snapshotResult);
          let label = pair?.round1.split('_')[0];
          if (label === 'col') {
            label = 'collaborative'
          }
          if (label === 'vis') {
            label = 'visionary'
          }
          if (label === 'strat') {
            label = 'strategic'
          }
          if (label === 'per') {
            label = 'performance'
          }
          labelsArray.push(label);
  
          // if (snapshotResult > highestScore) {
          //   highestScore = snapshotResult;
          //   highestVariable = pair?.round1;
          // }
        }
      });

      const labels_arr = ["performance", "strategic", "visionary", "collaborative"];


      const mostValues = [performance_r1_m,strategic_r1_m,visionary_r1_m,collaborative_r1_m];
      const secondMostValues = [performance_r2_m,strategic_r2_m,visionary_r2_m,collaborative_r2_m];
      const leastValues = [performance_r1_l,strategic_r1_l,visionary_r1_l,collaborative_r1_l];
      const secondLeastValues = [performance_r2_l,strategic_r2_l,visionary_r2_l,collaborative_r2_l];

      const most_score_label = Math.max(...mostValues);
      const second_most_score_label = Math.max(...secondMostValues);
      const least_score_label = Math.max(...leastValues);
      const second_least_score_label = Math.max(...secondLeastValues);

      const getLabel = (values, maxValue) => labels_arr[values.indexOf(maxValue)];

      const most_label = getLabel(mostValues, most_score_label);
      const second_most_label = getLabel(secondMostValues, second_most_score_label);
      const least_label = getLabel(leastValues, least_score_label);
      const second_least_label = getLabel(secondLeastValues, second_least_score_label);


      const getPercentageOrder = ( label ) => {

        if ( label == most_label?.toLowerCase() ) {
          return most_per;
        }
        if ( label == second_most_label?.toLowerCase() ) {
          return second_most_per;
        }
        if ( label == least_label?.toLowerCase() ) {
          return least_per;
        }
        if ( label == second_least_label?.toLowerCase() ) {
          return second_least_per;
        }

        return 0
      }


      results = [ getPercentageOrder("performance"),  getPercentageOrder("visionary") ,  getPercentageOrder("strategic") ,  getPercentageOrder("collaborative") ] // label order = 'performance', 'strategic', 'visionary', 'collaborative'


      console.log('highestVariable', highestVariable)
      console.log("pie chart results",results);
      console.log("pie chart labelsArray",labelsArray);
  
      setHighestLeadershipStarter(most_label);
      setLeadershipSnapshotResults(results);
      // setLeadershipLabels(["collaborative" , "strategic" , "performance", "visionary",  ]);
      getMostAndSecondMostVaribale(apiData)

    }
  }, [variablsMapArray]);

  const getMostAndSecondMostVaribale = (apiData) => {
    if (apiData?.variables?.length > 0) {
      const extractCoreVariable = (variable) =>
        variable?.split("_")[0];

      const highestRound1Variable = pairs
        ?.map((pair) => apiData?.variables.find((v) => v?.variable === pair?.round1))
        ?.filter(Boolean)
        ?.reduce((highest, current) => (current?.score > highest?.score ? current : highest), { score: -Infinity });

      const highestRound2Variable = pairs
        ?.map((pair) => apiData?.variables.find((v) => v?.variable === pair?.round2))
        ?.filter(Boolean)
        ?.reduce((highest, current) => (current?.score > highest?.score ? current : highest), { score: -Infinity });

      const coreRound1 = extractCoreVariable(highestRound1Variable?.variable);
      const coreRound2 = extractCoreVariable(highestRound2Variable?.variable);

      if (coreRound1 === coreRound2) {
        const secondHighestRound1Variable = pairs
          ?.map((pair) => apiData?.variables.find((v) => v?.variable === pair?.round1))
          ?.filter(Boolean)
          ?.sort((a, b) => b?.score - a?.score) // Sort by score
          ?.find((v) => v?.variable !== highestRound1Variable?.variable); // Find second highest

        setMostSelecTedStarter(highestRound1Variable?.variable || null);
        setSecondMostSelecTedStarter(secondHighestRound1Variable?.variable || null);
      } else {
        setMostSelecTedStarter(highestRound1Variable?.variable || null);
        setSecondMostSelecTedStarter(highestRound2Variable?.variable || null);
      }

      console.log(
        highestRound1Variable?.variable,
        highestRound2Variable?.variable,
        "highest"
      );
    }
  };

  const getStarterLogo = () => {
    if (highestStarter?.includes("heart")) return logo1;
    if (highestStarter?.includes("str")) return logo5;
    if (highestStarter?.includes("soul")) return logo7;
    if (highestStarter?.includes("mind")) return logo6;
    else return logo1;
  }

  const getLeadershiplogo = () => {
    if (highestLeadershipStarter.includes('col')) return collaborativelogo
    if (highestLeadershipStarter.includes('strat')) return stratrgiclogo
    if (highestLeadershipStarter.includes('per')) return performancelogo
    if (highestLeadershipStarter.includes('vis')) return visionarylogo
    else return logo1
  }

  const starterHeading = (logo) => {
    if(logo === logo1) return "Heart-Starter"
    if(logo === logo5) return "Strength-Starter"
    if(logo === logo7) return "Soul-Starter"
    if(logo === logo6) return "Mind-Starter"
    else return "None"
  }

  const getFlowImage = () => {
    const images = {
      HS: flow_HS,
      HM: flow_HM,
      HST: flow_HST,
      MH: flow_MH,
      MS: flow_MS,
      MST: flow_MST,
      SH: flow_SH,
      SM: flow_SM,
      SST: flow_SST,
      STH: flow_STH,
      STM: flow_STM,
      STS: flow_STS,
    };
    const mapStarter = (starter) => {
      if (starter?.includes("str")) return "ST";
      return starter?.split("_")[0][0]?.toUpperCase();
    };

    const key = `${mapStarter(mostSelecTedStarter)}${mapStarter(secondMostSelecTedStarter)}`;
    return images[key?.toUpperCase()] || overviewImg;
  };

  const getFlowHead = () => {

    const flowMapping = {
      HS: "Heart to Soul",
      HM: "Heart to Mind",
      HST: "Heart to Strength",
      MH: "Mind to Heart",
      MS: "Mind to Soul",
      MST: "Mind to Strength",
      SH: "Soul to Heart",
      SM: "Soul to Mind",
      SST: "Soul to Strength",
      STH: "Strength to Heart",
      STM: "Strength to Mind",
      STS: "Strength to Soul",
    };


    const mapStarter = (starter) => {
      if (starter?.includes("str")) return "ST";
      return starter?.split("_")[0][0]?.toUpperCase();
    };

    const key = `${mapStarter(mostSelecTedStarter)}${mapStarter(secondMostSelecTedStarter)}`;
    const flowText = flowMapping[key] || "";
    return flowText;
  };

  const getLeadershipHead = (logo) => {
    if(logo === collaborativelogo) return "Collaborative"
    if(logo === stratrgiclogo) return "Strategic"
    if(logo === performancelogo) return "Performance"
    if(logo === visionarylogo) return "Visionary"
    else return "None"
  }

  const getMindSetContent = () => {
    const mindSetVariable = apiData?.variables?.find(
      (item) => item?.variable === "mind_set_sum"
    );
  
    const score = mindSetVariable?.score ?? 0;
  
    let mindsetCategory;
    if (score <= 30) {
      mindsetCategory = "Fixed";
    } else if (score <= 34) {
      mindsetCategory = "Conditional";
    } else {
      mindsetCategory = "Growth";
    }
  
    return mindsetCategory;
  };

  const getMindsetLogo = (category) => {
    switch (category) {
      case "Growth":
        return GrowthLogo;
      case "Conditional":
        return ConditionalLogo;
      case "Fixed":
        return FixedLogo;
      default:
        return overviewImg;
    }
  };

  const mindsetCategory = getMindSetContent();

  console.log("mindsetCategory", mindsetCategory)

  return (
    <View style={styles.coverSection}>
      <View>
        <Text style={styles.coverTitle}>ABOUT YOUR REPORT</Text>
        <Text style={styles.paragraph}>
          Your Quadrant Flow assessment offers a structured analysis of your
          life and leadership, grounded in standardized testing. Such insights
          are invaluable for navigating decisions, career planning, and personal
          growth. However, it's crucial to recognize the inherent limitations of
          any assessment, especially a self-assessment limited to your own
          perspective of yourself. 
        </Text>
        <Text style={styles.paragraph}>
          Our 360 assessments include the combined data of selected Observers,
          allowing for objective conversation results. Quadrant Flow is a valid
          and reliable psychometric assessment but your results should be used
          as a starting point for discovery rather than conclusive judgment.
          Interpretations of the data can vary and may not be fully captured by
          the results. 
        </Text>
        <Text style={styles.paragraph}>
          For these reasons, it's highly recommended to review and interpret
          your Quadrant Flow assessment alongside a certified guide, coach,
          consultant, or trusted individual. This collaborative approach ensures
          that the insights gained are integrated thoughtfully into your
          personal and professional development plans. Remember, this report is
          a tool to aid in understanding yourself better, not a definitive
          measure of your capabilities or worth. 
        </Text>
        <Text style={styles.paragraph}>
          Quadrant Flow is not just a concept but a call to action, a blueprint
          for living a life of authenticity and fulfillment. It challenges us to
          look beyond the superficiality of societal norms and delve into the
          four dimensions of being human. By understanding these dimensions, we
          unlock the power that is uniquely ours. This power enables us to lead
          with wisdom and compassion, to thrive in our personal and professional
          lives, and to contribute to the greater good.
        </Text>
      </View>
      <View style={styles.secondsection}>
        <Text style={styles.subtitle}>QF - SNAPSHOT RESULTS</Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.paragraph}>
          Your Quadrant Flow offers a structured analysis of your life and
          leadership, grounded in standardized testing. These insights are
          invaluable for navigating decisions, career planning, and personal
          growth.
        </Text>
      </View>
      <View style={styles.section_container}>
        <View style={styles.card1}>
          <View style={styles.sections}>
            <Text style={styles.titles}>Starter</Text>
            <View style={styles.aligns}>
              <Image src={getStarterLogo()} style={styles.image} />
              <Text style={styles.subtitle}>SELF: {starterHeading(getStarterLogo())}</Text>
            </View>
          </View>
          <View style={styles.sections}>
            <Text style={styles.titles}>Flow</Text>
            <View style={styles.aligns}>
              <Image src={getFlowImage()} style={styles.image} />
              <Text style={styles.subtitle}>SELF: {getFlowHead()}</Text>
            </View>
          </View>
        </View>
        <View style={styles.card2}>
          <View style={styles.sections}>
            <Text style={styles.titles}>Leadership</Text>
            <View style={styles.aligns}>
              <Image src={getLeadershiplogo()} style={styles.image} />
              <Text style={styles.subtitle}>SELF: {getLeadershipHead(getLeadershiplogo())} </Text>
            </View>
          </View>
          <View style={styles.sections}>
            <Text style={styles.titles}>Mindset</Text>
            <View style={styles.aligns}>
              <Image src={getMindsetLogo(mindsetCategory)} style={styles.image} />
              <Text style={styles.subtitle}>SELF: {mindsetCategory}</Text>
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

export default AboutReport;
